import {
    NEW_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
    TABLE_BAIXAR_MANUAL_ESTOQUE_PENDING,
    TABLE_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
    TABLE_BAIXAR_MANUAL_ESTOQUE_FAILURE,
    LIST_BAIXAR_MANUAL_ESTOQUE_PENDING,
    LIST_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
    LIST_BAIXAR_MANUAL_ESTOQUE_FAILURE,
    FIND_BAIXAR_MANUAL_ESTOQUE_PENDING,
    FIND_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
    FIND_BAIXAR_MANUAL_ESTOQUE_FAILURE,
    DELETE_BAIXAR_MANUAL_ESTOQUE_PENDING,
    DELETE_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
    DELETE_BAIXAR_MANUAL_ESTOQUE_FAILURE,
    CREATE_BAIXAR_MANUAL_ESTOQUE_PENDING,
    CREATE_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
    CREATE_BAIXAR_MANUAL_ESTOQUE_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function baixarManualEstoqueReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_BAIXAR_MANUAL_ESTOQUE_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_BAIXAR_MANUAL_ESTOQUE_PENDING:
        case FIND_BAIXAR_MANUAL_ESTOQUE_PENDING:
        case DELETE_BAIXAR_MANUAL_ESTOQUE_PENDING:
        case CREATE_BAIXAR_MANUAL_ESTOQUE_PENDING:
        case TABLE_BAIXAR_MANUAL_ESTOQUE_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_BAIXAR_MANUAL_ESTOQUE_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_BAIXAR_MANUAL_ESTOQUE_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_BAIXAR_MANUAL_ESTOQUE_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_BAIXAR_MANUAL_ESTOQUE_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_BAIXAR_MANUAL_ESTOQUE_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_BAIXAR_MANUAL_ESTOQUE_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_BAIXAR_MANUAL_ESTOQUE_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_BAIXAR_MANUAL_ESTOQUE_SUCCESS:
        case CREATE_BAIXAR_MANUAL_ESTOQUE_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_BAIXAR_MANUAL_ESTOQUE_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { baixarManualEstoqueReducer };